import React, { useState, useEffect } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { collection, doc, updateDoc, addDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { auth, db } from "../../firebase";
import { Utils } from '../utils/Utils';
import "./Schedule.css";

const Schedule = () => {
  const [teams, setTeams] = useState([])  
  const [schedule, setSchedule] = useState([])
  const [matches, setMatches] = useState([])
  const [dateMatch, setDateMatch] = useState('')
  const [local, setLocal] = useState('')
  const [visitor, setVisitor] = useState('')
  const [ptsLocal, setPtsLocal] = useState('')
  const [ptsVisitor, setPtsVisitor] = useState('')
  const [urlStats, setUrlStats] = useState('')
  const [urlVideo, setUrlVideo] = useState('')
  const [observations, setObservations] = useState('')
  const [idSchedule, setIdSchedule] = useState('')
  const [idMatch, setIdMatch] = useState('')

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const PAGE_SIZE = 10;

  useEffect(() => {
    const getTeamsFromFirestore = async () => {
      try {
        const teamsCollectionRef = collection(db, 'teams');
        const teamsQuery = query(teamsCollectionRef, orderBy('name'));
        const snapshot = await getDocs(teamsQuery);
        const teamsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTeams(teamsData);
      } catch (error) {
        console.error('Error al obtener los datos de los equipos:', error);
      }
    };

    const getScheduleFromFirestore = async () => {
      try {
        const scheduleCollectionRef = collection(db, 'schedule');
        const scheduleQuery = query(scheduleCollectionRef);
        const snapshot = await getDocs(scheduleQuery);
        const scheduleData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        if (scheduleData.length > 0) {
          setIdSchedule(scheduleData[0].id)
          setSchedule(scheduleData[0])
          setMatches(scheduleData[0].schedule.sort((a,b)=> Utils.compareDates(a.dateMatch,b.dateMatch)));
        }
      } catch (error) {
        console.error('Error al obtener los datos de los partidos:', error);
      }
    };

    if (!user) return navigate("/")

    getTeamsFromFirestore();
    getScheduleFromFirestore();
  }, [user,navigate]);

  const columns = [
    {
      name: 'Fecha',
      selector: row => Utils.showDateStr(row['dateMatch']),
      sortable: true,
    },
    {
      name: 'Local',
      selector: row => getNameTeam(row['local']),
      sortable: true,
    },
    {
      name: 'Visitante',
      selector: row => getNameTeam(row['visitor']),
      sortable: true,
    },
    {
      name: 'Observaciones',
      selector: row => row['observations'],
      sortable: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEditar(e, row)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="M1.172,19.119A4,4,0,0,0,0,21.947V24H2.053a4,4,0,0,0,2.828-1.172L18.224,9.485,14.515,5.776Z"/><path d="M23.145.855a2.622,2.622,0,0,0-3.71,0L15.929,4.362l3.709,3.709,3.507-3.506A2.622,2.622,0,0,0,23.145.855Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      cell:(row) => <svg onClick={(e) => handleEliminar(e, row.id)} id={row.ID} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="iconAction"><path d="m17,4v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2h-6Zm-8-2h6v2h-6v-2Zm6.957,14.543l-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414,2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543Z"/></svg>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const handleGuardar = async () => {
    const nuevoPartido = {
      dateMatch: dateMatch,
      local: local,
      visitor: visitor,
      ptsLocal: ptsLocal * 1,
      ptsVisitor: ptsVisitor * 1,
      urlStats: urlStats,
      urlVideo: urlVideo,
      observations: observations
    };
    let scheduleRef 
    try {
      scheduleRef = doc (db, 'schedule', idSchedule)
    } catch (error) {
      console.error('Error al obtener el calendario: ', error)
    }
    const scheduleAfter = JSON.parse(JSON.stringify(schedule))
    scheduleAfter.schedule = matches
    if (idMatch === '') {
      nuevoPartido.id = Utils.generateRandomId(20)
      if (schedule.length === 0) {
        try {
          const newSchedule = {schedule: [nuevoPartido]}
          await addDoc(collection(db, 'schedule'), newSchedule)
          setMatches([nuevoPartido])
        } catch (error) {
          console.error('Error al agregar el partido:', error)
        }
      } else {
        scheduleAfter.schedule.push(nuevoPartido)
        try {
          await updateDoc(scheduleRef, scheduleAfter)
          setMatches([...matches])
        } catch (error) {
          console.error('Error al agregar el partido:', error)
        }
      }
      handleLimpiar()
    } else {
      try {
        nuevoPartido.id = idMatch
        Utils.replaceItemInArray(scheduleAfter.schedule, nuevoPartido)
        await updateDoc(scheduleRef, scheduleAfter)

        const nuevosPartidos = [...matches];
        const index = nuevosPartidos.map(e => e.id).indexOf(idMatch)
        
        nuevosPartidos[index] = nuevoPartido;
        setMatches(nuevosPartidos);
        handleLimpiar()
      } catch (error) {
        console.error('Error al modificar el partido:', error)
      }
    }
  };

  const handleEditar = (event, row) => {
    setDateMatch(row.dateMatch)
    setLocal(row.local)
    setVisitor(row.visitor)
    setPtsLocal(row.ptsLocal * 1)
    setPtsVisitor(row.ptsVisitor * 1)
    setUrlStats(row.urlStats)
    setUrlVideo(row.urlVideo)
    setObservations(row.observations)
    setIdMatch(row.id)
  };

  const handleEliminar = async (event, id) => {
    if (window.confirm("Está seguro que desea eliminar el partido?")) {
      const scheduleRef = doc (db, 'schedule', idSchedule)
      const scheduleAfter = schedule
      scheduleAfter.schedule = matches
      scheduleAfter.schedule = scheduleAfter.schedule.filter(match => match.id !== id)
      await updateDoc(scheduleRef, scheduleAfter)
      setMatches(scheduleAfter.schedule);
    }
  };

  const handleLimpiar = () => {
    setDateMatch('')
    setLocal('')
    setVisitor('')
    setPtsLocal('')
    setPtsVisitor('')
    setUrlStats('')
    setUrlVideo('')
    setObservations('')
    setIdMatch('')
  }

  const getNameTeam = id => {
    const teamsFiltered = teams.filter(team => id === team.id)
    if (teamsFiltered.length === 1) {
      return teamsFiltered[0].name
    } 
    return ""
  }

  const showTeams = () => {
    return teams.map(team => <option value={team.id}>{team.name}</option>)
  }

  return (
    <div className="container-schedule">
      <h2>Calendario pretemporada</h2>
      
      <h3>Agregar partido</h3>
      
      <input
        type="datetime-local"
        placeholder="Fecha"
        value={dateMatch}
        onChange={(e) => setDateMatch(e.target.value)}
      />
      <select 
      value={local}
      onChange={(e) => setLocal(e.target.value)}>
        <option value=""></option>
        {showTeams()}
      </select>

      <select 
      value={visitor}
      onChange={(e) => setVisitor(e.target.value)}>
        <option value=""></option>
        {showTeams()}
      </select>

      <input
          type="number"
          placeholder="Local"
          className="short"
          value={ptsLocal}
          onChange={(e) => setPtsLocal(e.target.value)}
        />
      <input
          type="number"
          placeholder="Visitante"
          className="short"
          value={ptsVisitor}
          onChange={(e) => setPtsVisitor(e.target.value)}
        />
      <input
        type="text"
        placeholder="URL estadísticas"
        value={urlStats}
        onChange={(e) => setUrlStats(e.target.value)}
      />

      <input
        type="text"
        placeholder="URL vídeo"
        value={urlVideo}
        onChange={(e) => setUrlVideo(e.target.value)}
      />
      <input
        type="text"
        placeholder="Observaciones"
        value={observations}
        onChange={(e) => setObservations(e.target.value)}
      />
      <button onClick={handleGuardar}>Guardar</button>
      <button onClick={handleLimpiar}>Limpiar</button>
      <div className="table">
        <DataTable
          columns={columns}
          data={matches}
          pagination
          paginationTotalRows={schedule.length}
          paginationPerPage={PAGE_SIZE}
          paginationRowsPerPageOptions={[PAGE_SIZE]}
      />
      </div>
    </div>
  );
};

export default Schedule;